import React, { useEffect, useState } from 'react';

const MemberDetailDrawer = ({ member, onClose, onSave }) => {
  const [draft, setDraft] = useState({
    commitmentLevel: 'unknown',
    childComfort: 'unknown',
    caregiverOpenness: 'unknown',
    notes: ''
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (member) {
      setDraft({
        commitmentLevel: member.commitmentLevel || 'unknown',
        childComfort: member.childComfort || 'unknown',
        caregiverOpenness: member.caregiverOpenness || 'unknown',
        notes: member.notes || ''
      });
    }
  }, [member]);

  if (!member) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    await onSave(member._id, draft);
    setSaving(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDraft((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="member-drawer">
      <header>
        <div>
          <h2>{member.name}</h2>
          <p>{member.relationshipToChild}</p>
        </div>
        <button type="button" onClick={onClose} className="secondary">
          Close
        </button>
      </header>
      <form onSubmit={handleSubmit}>
        <label>
          Commitment Level
          <select name="commitmentLevel" value={draft.commitmentLevel} onChange={handleChange}>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
            <option value="unknown">Unknown</option>
          </select>
        </label>
        <label>
          Child Comfort
          <select name="childComfort" value={draft.childComfort} onChange={handleChange}>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
            <option value="unknown">Unknown</option>
          </select>
        </label>
        <label>
          Caregiver Openness
          <select
            name="caregiverOpenness"
            value={draft.caregiverOpenness}
            onChange={handleChange}
          >
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
            <option value="unknown">Unknown</option>
          </select>
        </label>
        <label>
          Notes
          <textarea
            name="notes"
            value={draft.notes}
            onChange={handleChange}
            rows={4}
            placeholder="Add context, follow-ups, or supervision feedback"
          />
        </label>
        <button type="submit" className="primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save Updates'}
        </button>
      </form>
      <section className="member-drawer__contact">
        <h3>Contact Channels</h3>
        <dl>
          <dt>Phones</dt>
          <dd>{(member.phones || []).join(', ') || 'None recorded'}</dd>
          <dt>Emails</dt>
          <dd>{(member.emails || []).join(', ') || 'None recorded'}</dd>
          <dt>Addresses</dt>
          <dd>{(member.addresses || []).join('; ') || 'None recorded'}</dd>
        </dl>
      </section>
      <section className="member-drawer__provenance">
        <h3>Source Provenance</h3>
        <ul>
          {(member.sourceProvenance || []).map((source) => (
            <li key={source}>{source}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default MemberDetailDrawer;
